export const agencyActionTypes = {
  STORE_AGENCY_DETAILS: "STORE_AGENCY_DETAILS",
};
